var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-list-item-avatar',_vm._g(_vm._b({style:({
        'background-color': _vm.iconBackground,
        'margin-top': _vm.top ? '-20px' : 'default',
        'border-radius': '50%',
        border: _vm.iconBorder || 'none',
        'user-select': 'none'
      }),attrs:{"size":_vm.size},on:{"click":function($event){return _vm.$emit('click')}}},'v-list-item-avatar',attrs,false),on),[_c('span',{staticClass:"caption",style:({ color: _vm.iconColor })},[_vm._v(" "+_vm._s(_vm.iconInitials)+" ")])])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])}
var staticRenderFns = []

export { render, staticRenderFns }